/* Polsk katalog for locale-commerce-preferences-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'pref.salesMode': 'Domyślny widok nowej sprzedaży',
  'pref.salesModeSub': 'Dotyczy faktur, ofert, potwierdzeń zamówienia, faktur korygujących i innej sprzedaży. Widok możesz tymczasowo zmienić w formularzu.',
  'pref.purchaseMode': 'Domyślny widok nowych zakupów',
  'pref.purchaseModeSub': 'Wybierz, czy nowe zakupy mają się zwykle otwierać krok po kroku, czy z całym formularzem na jednej stronie.',
  'pref.mode.firstChoiceHelp': 'Ten wybór stanie się Twoim ustawieniem domyślnym. Możesz zmienić widok w formularzu lub zmienić ustawienie domyślne później w Ustawienia → Preferencje.',
  'pref.mode.saveFailed': 'Widok został zmieniony, ale nie udało się zapisać ustawienia domyślnego. Spróbuj ponownie w Ustawienia → Preferencje.',
  'pref.mode.unsupported': 'Nieprawidłowy wybór widoku.',
});
